module.exports = __webpack_public_path__ + "static/media/labra_tracker.e8e4df2a.png";